module.exports = __webpack_public_path__ + "img/1.1780b3d6.svg";